import type { FeatureFlags } from "../env/featureFlags.js";
import { TAB_CATALOG, TAB_ORDER, type TabId } from "./tabCatalog.js";

/**
 * 빌드별 탭 활성 필터 — Phaser 의존 0의 순수 모듈 (BottomTabView가 re-export).
 * 탭 정의(id/순서/배치/아이콘/게이트)의 SSoT는 `tabCatalog.ts` — 신규 탭은 거기 1줄.
 * 본 모듈은 기존 import 표면(TabId/TAB_ORDER/derive/filter) 호환 유지 + 필터 순수 함수 소유.
 * 일일상점은 별도 최상위 탭이 아니라 shop 탭 내 서브탭(ShopContainerTabView)이며,
 * featureFlags.dailyShop은 그 서브탭 노출 게이트다 (카탈로그 feature 키 미지정 사유).
 */
export { TAB_ORDER, type TabId } from "./tabCatalog.js";

/**
 * FeatureFlags → 활성 탭 집합. 카탈로그 `feature` 키가 지정된 탭만 게이트되므로
 * 신규 탭 추가 시 자동 포함(기본 활성). battle 등 핵심 탭은 항상 잔존.
 */
export function deriveEnabledTabSet(flags: FeatureFlags): ReadonlySet<TabId> {
  const set = new Set<TabId>(TAB_ORDER);
  for (const id of TAB_ORDER) {
    const feature = TAB_CATALOG[id].feature;
    if (feature && !flags[feature]) set.delete(id);
  }
  return set;
}

/** 활성 탭만 추린 표시 순서 — SingleSelection 구성원 필터용. 순서 보존. */
export function filterTabOrder(
  order: readonly TabId[],
  enabled: ReadonlySet<TabId>,
): readonly TabId[] {
  return order.filter((id) => enabled.has(id));
}

/**
 * 탭바 행 배치에서 비활성 탭 제거 + 빈 행 통째 제거.
 * 잔여 탭은 SegmentedTabBar가 width 기준 셀을 균등 분배하므로 빈 칸 없이 재배치된다.
 */
export function filterTabRows(
  rows: readonly (readonly TabId[])[],
  enabled: ReadonlySet<TabId>,
): readonly (readonly TabId[])[] {
  return rows
    .map((row) => row.filter((id) => enabled.has(id)))
    .filter((row) => row.length > 0);
}
